
    import { makeI18n } from '@/shared/lib/i18n';
    const baseTranslation = undefined
    
    
    if(module.hot) {
      const bucket = require("/app/build/i18n/browser-bucket.js");
      bucket.add('src/modules/vacancy/applicants-export/applicants-export.vue', {"title.list":{"ru_RU":"Лист кандидатов","en_US":"Applicants list"},"title.survey_type_a":{"ru_RU":"Обратная связь по кандидатам на вакансии","en_US":"Feedback on candidates for vacancy"},"title.survey_type_q":{"ru_RU":"Анкеты кандидатов на вакансии","en_US":"Candidate questionnaires for vacancy"},"error.empty.survey_type_a":{"ru_RU":"На выбранных этапах нет кандидатов с формами обратной связи","en_US":"No applicants with feedback at the selected statuses"},"error.empty.survey_type_q":{"ru_RU":"На выбранных этапах нет кандидатов с анкетами","en_US":"No applicants with questionnaires at the selected statuses"}}) 
    }
   
    
    export default function (Component) {
      function beforeCreateI18n() {
        this.$i18n = this.$options._i18n;
      }

      function addHook(current) {
        if (Array.isArray(current)) {
          return [beforeCreateI18n].concat(current);
        } 
        if (current) {
          return [beforeCreateI18n, current];
        }
        return [beforeCreateI18n];
      }
    
      Component._i18n = makeI18n("src/modules/vacancy/applicants-export/applicants-export.vue", baseTranslation);
      Component.beforeCreate = addHook(Component.beforeCreate);
      delete Component._Ctor;
    }
  